var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindAProvider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "10 10 60.07 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_1914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5164 29.9568H40.4576V22.959H29.6079V29.9568H22.5491V40.8423H29.6079V47.8402H40.4576V40.8423H47.5164V29.9568Z",
    fill: "#F2B543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5164 56.2635L59.5425 68.1857C61.8955 70.5183 65.817 70.5183 68.3007 68.1857C70.6536 65.8531 70.6536 61.9654 68.3007 59.5032L56.4053 47.7106C55.3595 49.3952 54.183 50.8207 52.8758 52.2462C51.1765 53.9309 49.3464 55.2268 47.5164 56.2635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6209 60.6695C28.9543 60.6695 22.4183 58.0778 17.5817 53.2829C12.6144 48.4881 10 42.1382 10 35.3996C10 28.5313 12.6144 22.1814 17.451 17.3866C27.3856 7.5378 43.5948 7.5378 53.6601 17.3866C62.0261 25.6803 63.5948 38.3801 57.451 48.4881C56.4052 50.3024 55.098 51.8575 53.6601 53.2829C52.0915 54.838 50.1307 56.2635 48.1699 57.4298C44.2484 59.6328 39.9346 60.6695 35.6209 60.6695ZM35.6209 12.5918C29.7386 12.5918 23.8562 14.7948 19.4118 19.2009C14.9673 23.6069 12.6144 29.3089 12.6144 35.3996C12.6144 41.4903 14.9673 47.1922 19.281 51.4687C26.4706 58.5961 37.8431 60.1512 46.732 55.2268C48.5621 54.1901 50.2614 52.8942 51.6993 51.4687C53.0065 50.1728 54.0523 48.7473 55.098 47.1922C60.5882 38.2505 59.1503 26.7171 51.6993 19.3305C47.3856 14.7948 41.5033 12.5918 35.6209 12.5918Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindAProvider);
export default __webpack_public_path__ + "static/media/find-a-provider.815c8e24e742bd691c7953991f13e098.svg";
export { ForwardRef as ReactComponent };